import { HttpHeaders } from '@angular/common/http';

import { AuthService } from '../_services/auth.service';
export class AuthHeader {
  token:string=undefined
  constructor(private tss:AuthService){

  }
  openTextHeaders= { headers: new HttpHeaders({ 'Content-Type': 'text/plain','Authorization':`Bearer ${this.tss.getToken()}`}), responseType: 'text' as 'json' };
  openJsonHeaders = { headers: new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${this.tss.getToken()}`}), responseType: 'text' as 'json' };
  bearerTextHeaders = { headers: new HttpHeaders({ 'Content-Type': 'text/plain', 'Authorization':`Bearer ${this.tss.getToken()}`}), responseType: 'text' as 'json' };
  bearerJsonHeaders = { headers: new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${this.tss.getToken()}`}), responseType: 'text' as 'json' };
  bearerFormHeaders = {headers: new HttpHeaders({ 'Authorization':`Bearer ${this.tss.getToken()}`,'Content-Type': 'application/x-www-form-urlencoded' } ),responseType: 'text' as 'json'};
  openFormHeaders = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded','Authorization':'' } ),responseType: 'text' as 'json'};
  bearerFormMultipartHeaders = {headers: new HttpHeaders({'Authorization':`Bearer ${this.tss.getToken()}` } ),responseType: 'text' as 'json'};
}

